import { useState } from 'react'
import { useSelector } from 'react-redux'

import { selectToken } from '../authentication/authenticationSlice'
import api from '../api'
import { IOrganizationUser } from 'types'

const useGetOrganizationUsers = () => {
  const token = useSelector(selectToken)

  const [organizationUsers, setOrganizationUsers] = useState<IOrganizationUser[]>()
  const [loadingOrganizationUsers, setLoadingOrganizationUsers] = useState(true)
  const [loadingAllOrganizationUsers, setLoadingAllOrganizationUsers] = useState(false)
  const [organizationUsersError, setOrganizationUsersError] = useState(false)

  const getOrganizationUsers = async ({ organization }) => {
    const organizationId = organization.id

    try {
      const responseOrganizationUsers = await api.getOrganizationUsers({
        organizationId,
        token,
      })

      setOrganizationUsers(responseOrganizationUsers)
      setLoadingOrganizationUsers(false)
    } catch {
      setOrganizationUsersError(true)
    }
    setLoadingOrganizationUsers(false)
  }

  const getAllOrganizationUsers = async ({ organizationId }): Promise<IOrganizationUser[]> => {
    try {
      setLoadingAllOrganizationUsers(true)
      const responseOrganizationUsers = await api.getAllOrganizationUsers({
        organizationId,
        token,
      })
      setLoadingAllOrganizationUsers(false)
      return responseOrganizationUsers
    } catch {
      setLoadingAllOrganizationUsers(false)
      console.error('Error fetching all organization users')
      return []
    }
  }

  return {
    organizationUsers,
    loadingOrganizationUsers,
    loadingAllOrganizationUsers,
    organizationUsersError,
    getOrganizationUsers,
    getAllOrganizationUsers,
  }
}

export default useGetOrganizationUsers
